import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { getOffers } from "../API/HomeAPI";

const CouponSidebar = ({ offer, onClose }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(offer.CODE);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <div
        className="fixed inset-0 bg-black/40 z-40"
        onClick={onClose}
      />
      <div className="fixed top-0 right-0 h-full w-80 bg-white z-50 shadow-2xl flex flex-col">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="font-semibold text-lg">{offer.Title}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
        </div>

        <div className="overflow-y-auto flex-1 p-4 flex flex-col gap-4">
          <img
            src={offer.BannerImageW || offer.BannerImageA}
            alt={offer.Title}
            className="w-full rounded-lg object-cover"
          />

          {offer.Content && (
            <div
              className="text-sm text-contentcolor"
              dangerouslySetInnerHTML={{ __html: offer.Content }}
            />
          )}

          <div className="text-sm text-gray-600 space-y-1">
            {offer.Amount > 0 && (
              <p>Discount: <span className="font-semibold text-theme2">
                {offer.Type === 1 ? `₹${offer.Amount} OFF` : `${offer.Amount}% OFF`}
              </span></p>
            )}
            {offer.MinAmount > 0 && (
              <p>Min. Order: <span className="font-semibold">₹{offer.MinAmount}</span></p>
            )}
          </div>

          {offer.CODE && (
            <div className="border-2 border-dashed border-theme2 rounded-lg p-3 flex items-center justify-between gap-2 bg-orange-50">
              <span className="font-mono font-bold text-theme2 tracking-widest text-sm">{offer.CODE}</span>
              <button
                onClick={handleCopy}
                className="text-xs bg-theme2 text-white px-3 py-1.5 rounded-md font-medium shrink-0"
              >
                {copied ? "Copied!" : "Copy"}
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const DealsSection = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    getOffers().then((data) => {
      setOffers(data || []);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="container mx-auto px-4 bg-white py-10">
        <div className="h-5 bg-gray-200 rounded w-40 mb-3 animate-pulse" />
        <div className="h-4 bg-gray-200 rounded w-64 mb-6 animate-pulse" />
        <div className="grid grid-cols-2 md:grid-cols-5 gap-5">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="w-full h-44 bg-gray-200 rounded-lg animate-pulse" />
          ))}
        </div>
      </div>
    );
  }

  if (!offers.length) return null;

  return (
    <div className="container mx-auto px-4 bg-white py-10">
      <div className="loader-line" />
      <h2 className="md:text-3xl sm:text-2xl text-xl mt-4 font-semibold mb-2">Today's Deals</h2>
      <p className="mb-5 text-contentcolor">Take a benefit from our latest offers.</p>

      <Swiper
        modules={[Autoplay]}
        loop={offers.length > 2}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        spaceBetween={16}
        breakpoints={{
          120: { slidesPerView: 1.2 },
          480: { slidesPerView: 2 },
          640: { slidesPerView: 2.5 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
          1280: { slidesPerView: 5 },
        }}
      >
        {offers.map((offer) => (
          <SwiperSlide key={offer.Id}>
            <div
              className="rounded-lg overflow-hidden shadow-sm border border-gray-100 bg-white hover:shadow-md transition-shadow duration-300 cursor-pointer"
              onClick={() => setSelected(offer)}
            >
              <img
                src={offer.BannerImageW || offer.BannerImageA || offer.Image}
                alt={offer.Title || "Offer"}
                className="w-full   object-cover"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {selected && (
        <CouponSidebar offer={selected} onClose={() => setSelected(null)} />
      )}
    </div>
  );
};

export default DealsSection;
